import { useDispatch } from 'react-redux';

import {
	ClickToCallAllInternationalDialingPhoneCodesInputDto,
	ClickToCallAllInternationalDialingPhoneCodesOutputDto,
} from '@api/ecommerce-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchClickToCallAllInternationalDialingPhoneCodes = (): UseFetchHookOutput<
	Omit<ClickToCallAllInternationalDialingPhoneCodesInputDto, 'metadata'>,
	ClickToCallAllInternationalDialingPhoneCodesOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<
		ClickToCallAllInternationalDialingPhoneCodesInputDto,
		ClickToCallAllInternationalDialingPhoneCodesOutputDto
	>({
		operationKey: 'clickToCallAllInternationalDialingPhoneCodes',
		withLoading: false,
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ clickToCallAllInternationalDialingPhoneCodes: res.data }));
			}
		},
	});
};
